import React from "react";
import { useContext, createContext } from "react";
import { createPortal } from "react-dom";
import { X } from "react-bootstrap-icons";

const ModalContext = createContext();

const DissmissButton = ({ children, className }) => {
  const {onClose} = useContext(ModalContext)

  return (
    <button type="button" onClick={onClose} className={className}>{children}</button>
  )
}

const ModalHeader = ({ children }) => {
  return (
    <div className="modal-header dark:bg-rb-dark-mode dark:border-b dark:border-rb-dark-mode-lighter">
      <div className="modal-title dark:text-white">{children}</div>
      <DissmissButton className="btn-close"><X className="text-3xl p-1 rounded-lg hover:bg-gray-200 dark:text-white dark:hover:bg-rb-dark-mode-lighter" /></DissmissButton>
    </div>
  )
}

const ModalBody = ({children}) => {
  return (
    <div className="modal-body dark:bg-rb-dark-mode">
      {children}
    </div>
  )
}

const ModalFooter = ({ children }) => {
  return (
    <div className="modal-footer dark:bg-rb-dark-mode dark:border-t dark:border-rb-dark-mode-lighter">
      {children}
    </div>
  )
}

const Modal = ({ children, isOpen, onClose, hasSideBar, maxHeight = 'calc(100vh - 100px)' }) => {
  if (!isOpen || typeof document === 'undefined') return null

  return createPortal(
    <div className="modal-overlay">
      <div className={`modal-wrapper ${hasSideBar ? 'pl-56' : ''}`}>
        <div className="modal-content dark:bg-rb-dark-mode dark:border-rb-dark-mode-lighter" style={{ maxHeight }}>
          <ModalContext.Provider value={{ onClose }}>
            {children}
          </ModalContext.Provider>
        </div>
      </div>
    </div>,
    document.body,
  );
}

Modal.Header = ModalHeader
Modal.Body = ModalBody
Modal.Footer = ModalFooter
Modal.DissmissButton = DissmissButton

export default Modal;
